export const radius = {
    xs: '2px',
    s: '4px',
    m: '8px',
    pill: '100px',
};
